import { TbDatabaseSearch, TbMathFunction, TbTextScan2, TbUserScan } from 'react-icons/tb';

import { ConnectedAccountType, ListType } from '@/types';

import { ListColumnStyleParams } from './types';

interface CreateListColumnOptionsParams extends Pick<ListColumnStyleParams, 'sectionIconStyle'> {
    companyListColumns: any[];
    financialListColumns: any[];
    listType: ListType;
    mergedDataSourceListColumns: any[];
    peopleListColumns: any[];
}

export const createListColumnOptions = ({
    companyListColumns,
    financialListColumns,
    listType,
    mergedDataSourceListColumns,
    peopleListColumns,
    sectionIconStyle,
}: CreateListColumnOptionsParams) => {
    const sectionToAccountTypeMap = {
        dataSources: [
            ConnectedAccountType.AIRTABLE,
            ConnectedAccountType.ASANA,
            ConnectedAccountType.ATTIO,
            ConnectedAccountType.BOX,
            ConnectedAccountType.CLICKUP,
            ConnectedAccountType.CODA,
            ConnectedAccountType.CONFLUENCE,
            ConnectedAccountType.DOCUSIGN,
            ConnectedAccountType.DROPBOX,
            ConnectedAccountType.GOOGLE_DRIVE,
            ConnectedAccountType.GOOGLE_SHEETS,
            ConnectedAccountType.HUBSPOT,
            ConnectedAccountType.MIRO,
            ConnectedAccountType.MONDAY,
            ConnectedAccountType.NOTION,
            ConnectedAccountType.PIPEDRIVE,
            ConnectedAccountType.SLACK,
            ConnectedAccountType.SMARTSHEET,
            // ConnectedAccountType.WEALTHBOX,
            ConnectedAccountType.WRIKE,
        ],
    } as any;

    const listColumnOptionsMap = {
        [ListType.PEOPLE]: [
            {
                key: 'people',
                label: 'People',
                icon: <TbUserScan size='0.875rem' style={{ ...sectionIconStyle }} />,
                options: peopleListColumns as any,
            },
            {
                key: 'dataSources',
                label: 'Data Sources',
                icon: <TbDatabaseSearch size='0.875rem' style={{ ...sectionIconStyle }} />,
                options: mergedDataSourceListColumns,
            },
        ],
        [ListType.COMPANIES]: [
            {
                key: 'companies',
                label: 'Companies',
                icon: <TbTextScan2 size='0.875rem' style={{ ...sectionIconStyle }} />,
                options: companyListColumns as any,
            },
            {
                key: 'financials',
                label: 'Financials',
                icon: <TbMathFunction size='0.875rem' style={{ ...sectionIconStyle }} />,
                options: financialListColumns as any,
            },
            {
                key: 'dataSources',
                label: 'Data Sources',
                icon: <TbDatabaseSearch size='0.875rem' style={{ ...sectionIconStyle }} />,
                options: mergedDataSourceListColumns,
            },
        ],
        [ListType.CUSTOM]: [
            {
                key: 'people',
                label: 'People',
                icon: <TbUserScan size='0.875rem' style={{ ...sectionIconStyle }} />,
                options: peopleListColumns as any,
            },
            {
                key: 'companies',
                label: 'Companies',
                icon: <TbTextScan2 size='0.875rem' style={{ ...sectionIconStyle }} />,
                options: companyListColumns as any,
            },
            {
                key: 'financials',
                label: 'Financials',
                icon: <TbMathFunction size='0.875rem' style={{ ...sectionIconStyle }} />,
                options: financialListColumns as any,
            },
            {
                key: 'dataSources',
                label: 'Data Sources',
                icon: <TbDatabaseSearch size='0.875rem' style={{ ...sectionIconStyle }} />,
                options: mergedDataSourceListColumns,
            },
        ],
    } as Record<ListType, any>;

    const listColumns = (listColumnOptionsMap[listType] ?? []).map((section: any) => ({
        key: section.key,
        label: section.label,
        icon: section.icon,
        options: section.options ?? [],
        hint: section.hint, // future-proof
    }));

    return { listColumnOptionsMap, sectionToAccountTypeMap, listColumns };
};
